<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'usersCrud'"
          crudName="Unidades de Saúde"
          newText="Novo"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "unidadeSaudeTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: ["id", "unidade_saude_nome", "tipo_unidade_saude_id", "actions"],
      tableData: ["id","unidade_saude_id", "unidade_saude_nome", "tipo_unidade_saude_id", "endereco", "bairro", "complemento", "cep", "ponto_referencia", "telefone", "cnes", "situacao_unidade", "data_registro", "numero", "municipio_id", "tipo_unidade_saude_id"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "unidade_saude_nome"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          unidade_saude_nome: "Nome da Unidade", 
          municipio_id: "Municipio", 
          tipo_unidade_saude_id: "Tipo da Unidade",
          actions: "Ações"
        },
        sortable: [
          "unidade_saude_nome",
        ],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {
           tipo_unidade_saude_id: function (h, row, index) {
            return row.tipo_unidade_saude_id ? row.tipo_unidade_saude.tipo_unidade_saude_nome : "Sem Nome";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["tipo_unidade_saude"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "unidade_saude",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    query: function (query) {
      let columns = {
        id: "id",
        unidade_saude_nome: "unidade_saude_nome",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>